document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('#product-grid img').forEach(function(img) {
    img.setAttribute('loading', 'eager');
  });
});// Suppress auto-focus on postcode input at page load only
var _blurGuard = Date.now();
document.addEventListener('focus', function(e) {
  if (Date.now() - _blurGuard < 1500 && e.target.tagName === 'INPUT') {
    e.target.blur();
  }
}, true);document.addEventListener('DOMContentLoaded', function () {
  function getPrimaryOptionSelect() {
    return document.querySelector('select[name="options[Size]"], select[name="options[Select your colourway]"]');
  }

  function getAllDropdownWrappers() {
    return Array.from(document.querySelectorAll('.product-form__input--dropdown'));
  }

  function getSecondaryOptionWrappers() {
    const primarySelect = getPrimaryOptionSelect();
    if (!primarySelect) return [];
    return getAllDropdownWrappers().filter(function (wrapper) {
      return !wrapper.contains(primarySelect);
    });
  }

  function getBespokeSelect() {
    const secondaryWrappers = getSecondaryOptionWrappers();
    for (const wrapper of secondaryWrappers) {
      const label = wrapper.querySelector('label');
      const select = wrapper.querySelector('select');
      if (!select) continue;
      const labelText = (label ? label.textContent : '').trim().toLowerCase();
      const firstOption = select.querySelector('option');
      const firstOptionText = firstOption ? firstOption.textContent.trim().toLowerCase() : '';
      if (labelText.includes('bespoke quantity') || firstOptionText.includes('bespoke quantity')) return select;
    }
    return secondaryWrappers.map(function (wrapper) {
      return wrapper.querySelector('select');
    }).find(Boolean);
  }

  function getQuantityBlock() {
    return document.querySelector('.price-per-item__container');
  }

  function getQuantityInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function getInfiniteOptionsBlock() {
    return document.querySelector('#wtf-native-options-container, #infiniteoptions-container');
  }

  function getAddToCartButton() {
    return document.querySelector('button[name="add"]');
  }

  function getProductForm() {
    const addButton = getAddToCartButton();
    return addButton ? addButton.closest('form') : null;
  }

  function getOrCreateFormPropertyInput(form, propertyName) {
    if (!form || !propertyName) return null;

    let input = form.querySelector('input[type="hidden"][name="properties[' + propertyName + ']"][data-wtf-property-mirror="true"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + propertyName + ']';
      input.setAttribute('data-wtf-property-mirror', 'true');
      form.appendChild(input);
    }

    return input;
  }

  const cardMessageTemplates = [
    {
      label: 'Happy Birthday',
      message: 'Happy Birthday'
    },
    {
      label: 'Get Well Soon',
      message: 'Get Well Soon'
    },
    {
      label: 'Anniversary',
      message: 'Happy Anniversary'
    },
    {
      label: 'Baby',
      message: 'Congratulations on your new baby'
    },
    {
      label: 'Sympathy',
      message: 'With deepest sympathy'
    }
  ];

  function formatDateForZapier(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return days[date.getDay()] + ', ' + date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear() + '|';
  }

  function getDateKey(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  function getStartOfToday() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  function buildNativeLineItemOptions() {
    const form = getProductForm();
    if (!form) return;

    const oldInfiniteOptions = document.querySelector('#infiniteoptions-container');
    if (oldInfiniteOptions) {
      oldInfiniteOptions.style.display = 'none';
      oldInfiniteOptions.setAttribute('aria-hidden', 'true');
    }

    let container = document.querySelector('#wtf-native-options-container');

    if (!container) {
      container = document.createElement('div');
      container.id = 'wtf-native-options-container';
      container.className = 'wtf-native-options hidden-until-size';

      const deliveryOption = document.createElement('div');
      deliveryOption.className = 'wtf-native-option wtf-native-option--delivery';

      const deliveryLabel = document.createElement('label');
      deliveryLabel.className = 'wtf-native-option__label';
      deliveryLabel.setAttribute('for', 'wtf-delivery-date');
      deliveryLabel.textContent = 'Delivery Date';

      const deliveryWrapper = document.createElement('div');
      deliveryWrapper.className = 'wtf-native-datepicker';

      const deliveryInput = document.createElement('input');
      deliveryInput.type = 'text';
      deliveryInput.id = 'wtf-delivery-date';
      deliveryInput.name = 'properties[Delivery Date]';
      deliveryInput.placeholder = 'Select delivery date';
      deliveryInput.readOnly = true;
      deliveryInput.required = true;
      deliveryInput.setAttribute('aria-required', 'true');
      deliveryInput.autocomplete = 'off';

      const calendar = document.createElement('div');
      calendar.className = 'wtf-native-calendar';
      calendar.setAttribute('aria-hidden', 'true');

      deliveryWrapper.append(deliveryInput, calendar);
      deliveryOption.append(deliveryLabel, deliveryWrapper);

      const choiceOption = document.createElement('div');
      choiceOption.className = 'wtf-native-option wtf-native-option--card-choice';

      const choiceLabel = document.createElement('label');
      choiceLabel.className = 'wtf-native-option__label';
      choiceLabel.setAttribute('for', 'wtf-card-message-choice');
      choiceLabel.textContent = 'Card Message Option';

      const choiceSelect = document.createElement('select');
      choiceSelect.id = 'wtf-card-message-choice';
      choiceSelect.className = 'wtf-card-message-choice';
      choiceSelect.required = true;
      choiceSelect.setAttribute('aria-required', 'true');

      const blankChoice = document.createElement('option');
      blankChoice.value = '';
      blankChoice.textContent = 'Would you like to add a card message?';

      const cardChoice = document.createElement('option');
      cardChoice.value = 'card_message';
      cardChoice.textContent = 'Card message';

      const noCardChoice = document.createElement('option');
      noCardChoice.value = 'no_card';
      noCardChoice.textContent = 'No card message needed';

      choiceSelect.append(blankChoice, cardChoice, noCardChoice);
      choiceOption.append(choiceLabel, choiceSelect);

      const messageOption = document.createElement('div');
      messageOption.className = 'wtf-native-option wtf-native-option--message is-hidden';

      const messageLabel = document.createElement('label');
      messageLabel.className = 'wtf-native-option__label';
      messageLabel.setAttribute('for', 'wtf-card-message');
      messageLabel.textContent = 'Card Message';

      const messageTextarea = document.createElement('textarea');
      messageTextarea.id = 'wtf-card-message';
      messageTextarea.name = 'properties[Card Message]';
      messageTextarea.placeholder = 'Type your message here...';
      messageTextarea.maxLength = 250;
      messageTextarea.rows = 6;
      messageTextarea.required = true;
      messageTextarea.setAttribute('aria-required', 'true');

      const count = document.createElement('div');
      count.className = 'wtf-card-message-count';
      count.textContent = '250 Characters left';

      const templateButtons = document.createElement('div');
      templateButtons.className = 'wtf-card-message-templates';

      cardMessageTemplates.forEach(function (template) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wtf-card-message-template';
        button.dataset.message = template.message;
        button.textContent = template.label;
        templateButtons.appendChild(button);
      });

      messageOption.append(messageLabel, messageTextarea, count, templateButtons);
      container.append(deliveryOption, choiceOption, messageOption);

      const quantityBlock = getQuantityBlock();
      const addButton = getAddToCartButton();
      const insertionTarget = quantityBlock || (addButton ? addButton.closest('.product-form__buttons, .product-buy-buttons-wrapper') : null);

      if (insertionTarget && insertionTarget.parentNode) {
        insertionTarget.parentNode.insertBefore(container, insertionTarget);
      } else {
        form.appendChild(container);
      }
    }

    container.classList.add('wtf-native-options');

    const deliveryInput = container.querySelector('#wtf-delivery-date');
    const calendar = container.querySelector('.wtf-native-calendar');
    const deliveryMirror = getOrCreateFormPropertyInput(form, 'Delivery Date');
    const choiceSelect = container.querySelector('#wtf-card-message-choice');
    const messageOption = container.querySelector('.wtf-native-option--message');
    const messageTextarea = container.querySelector('#wtf-card-message');
    const messageMirror = getOrCreateFormPropertyInput(form, 'Card Message');
    const count = container.querySelector('.wtf-card-message-count');
    const templateButtons = Array.from(container.querySelectorAll('.wtf-card-message-template'));

    if (deliveryInput && calendar) {
      if (deliveryMirror) {
        deliveryMirror.value = deliveryInput.value || '';

        deliveryInput.addEventListener('input', function () {
          deliveryMirror.value = deliveryInput.value || '';
        });

        deliveryInput.addEventListener('change', function () {
          deliveryMirror.value = deliveryInput.value || '';
        });
      }

      initNativeDatepicker(deliveryInput, calendar);
    }

    if (messageTextarea && count && messageTextarea.dataset.wtfMessageInitialized !== 'true') {
      messageTextarea.dataset.wtfMessageInitialized = 'true';

      const noCardMessage = 'No card needed';

      const updateMessageCount = function () {
        const maxLength = Number(messageTextarea.getAttribute('maxlength')) || 250;
        const remaining = Math.max(0, maxLength - messageTextarea.value.length);
        count.textContent = remaining + ' Characters left';

        if (messageMirror) {
          messageMirror.value = messageTextarea.value || '';
        }
      };

      const updateCardMessageMode = function () {
        if (!choiceSelect || !messageOption) return;

        if (choiceSelect.value === 'card_message') {
          messageOption.classList.remove('is-hidden');

          if (messageTextarea.value === noCardMessage) {
            messageTextarea.value = '';
          }
        } else {
          messageOption.classList.add('is-hidden');

          if (choiceSelect.value === 'no_card') {
            messageTextarea.value = noCardMessage;
          } else if (messageTextarea.value === noCardMessage) {
            messageTextarea.value = '';
          }
        }

        messageTextarea.dispatchEvent(new Event('input', { bubbles: true }));
        messageTextarea.dispatchEvent(new Event('change', { bubbles: true }));
      };

      templateButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          const maxLength = Number(messageTextarea.getAttribute('maxlength')) || 250;
          const message = button.dataset.message || button.textContent || '';
          messageTextarea.value = message.slice(0, maxLength);
          messageTextarea.dispatchEvent(new Event('input', { bubbles: true }));
          messageTextarea.dispatchEvent(new Event('change', { bubbles: true }));
          messageTextarea.focus();
        });
      });

      if (choiceSelect) {
        choiceSelect.addEventListener('change', updateCardMessageMode);
        updateCardMessageMode();
      }

      messageTextarea.addEventListener('input', updateMessageCount);
      updateMessageCount();
    }
  }

  function initNativeDatepicker(input, calendar) {
    if (input.dataset.wtfDatepickerInitialized === 'true') return;
    input.dataset.wtfDatepickerInitialized = 'true';

    let visibleMonth = new Date();
    visibleMonth.setDate(1);

    function renderCalendar() {
      const today = getStartOfToday();
      const selectedKey = input.dataset.dateKey || '';
      const month = visibleMonth.getMonth();
      const year = visibleMonth.getFullYear();
      const firstDay = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const startDay = firstDay.getDay();
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const dayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

      calendar.innerHTML = '';

      const header = document.createElement('div');
      header.className = 'wtf-native-calendar__header';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'wtf-native-calendar__nav wtf-native-calendar__nav--prev';
      prev.textContent = 'Prev';

      const title = document.createElement('div');
      title.className = 'wtf-native-calendar__title';
      title.textContent = monthNames[month] + ' ' + year;

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'wtf-native-calendar__nav wtf-native-calendar__nav--next';
      next.textContent = 'Next';

      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        visibleMonth = new Date(year, month - 1, 1);
        renderCalendar();
      });

      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        visibleMonth = new Date(year, month + 1, 1);
        renderCalendar();
      });

      header.append(prev, title, next);
      calendar.appendChild(header);

      const grid = document.createElement('div');
      grid.className = 'wtf-native-calendar__grid';

      dayLabels.forEach(function (label) {
        const dayName = document.createElement('div');
        dayName.className = 'wtf-native-calendar__day-name';
        dayName.textContent = label;
        grid.appendChild(dayName);
      });

      for (let i = 0; i < startDay; i++) {
        const blank = document.createElement('div');
        blank.className = 'wtf-native-calendar__blank';
        blank.innerHTML = '&nbsp;'; // <--- Add this line
        grid.appendChild(blank);
      }

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        const dateKey = getDateKey(date);
        const isPast = date < today;

        const dayButton = document.createElement('button');
        dayButton.type = 'button';
        dayButton.className = 'wtf-native-calendar__day';
        dayButton.textContent = String(day);
        dayButton.disabled = isPast;
        dayButton.classList.toggle('is-selected', dateKey === selectedKey);

        dayButton.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          input.value = formatDateForZapier(date);
          input.dataset.dateKey = dateKey;
          calendar.classList.remove('is-open');
          calendar.setAttribute('aria-hidden', 'true');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        grid.appendChild(dayButton);
      }

      calendar.appendChild(grid);
    }

    calendar.addEventListener('click', function (event) {
      event.stopPropagation();
    });

    input.addEventListener('click', function (event) {
      event.stopPropagation();
      renderCalendar();
      calendar.classList.add('is-open');
      calendar.setAttribute('aria-hidden', 'false');
    });

    input.addEventListener('focus', function () {
      renderCalendar();
      calendar.classList.add('is-open');
      calendar.setAttribute('aria-hidden', 'false');
    });

    document.addEventListener('click', function (event) {
      if (!calendar.parentNode.contains(event.target)) {
        calendar.classList.remove('is-open');
        calendar.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function setQuantityMin(quantityInput, minValue) {
    quantityInput.min = String(minValue);
    quantityInput.setAttribute('min', String(minValue));
    quantityInput.dataset.min = String(minValue);
    quantityInput.setAttribute('data-min', String(minValue));
  }

  function showMinQtyMessage(message) {
    const quantityBlock = getQuantityBlock();
    if (!quantityBlock) return;
    let popup = quantityBlock.querySelector('.bespoke-min-qty-message');
    if (!popup) {
      popup = document.createElement('div');
      popup.className = 'bespoke-min-qty-message';
      quantityBlock.appendChild(popup);
    }
    popup.textContent = message;
    popup.classList.add('is-visible');
    clearTimeout(popup._hideTimer);
    popup._hideTimer = setTimeout(function () {
      popup.classList.remove('is-visible');
    }, 2200);
  }

  function isBespokeActive() {
    const bespokeSelect = getBespokeSelect();
    if (!bespokeSelect) return false;
    const firstOption = bespokeSelect.querySelector('option');
    const placeholderValue = firstOption ? firstOption.value : '';
    return bespokeSelect.value === placeholderValue;
  }

  function getBespokeMinQty() {
    const quantityBlock = getQuantityBlock();
    if (!quantityBlock) return 1;
    return parseInt(quantityBlock.dataset.bespokeMinQty || '1', 10);
  }

  function hasPrimaryVariantChoice() {
    const primarySelect = getPrimaryOptionSelect();
    if (!primarySelect) return true;
    return primarySelect.value !== '';
  }

  function getVisibleRequiredFields() {
    const container = getInfiniteOptionsBlock();
    if (!container) return [];
    return Array.from(container.querySelectorAll('input[required], textarea[required], select[required]')).filter(function (field) {
      if (field.disabled) return false;
      if (field.type === 'hidden') return false;
      return field.offsetParent !== null;
    });
  }

  function getInvalidRequiredFields() {
    return getVisibleRequiredFields().filter(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') return !field.checked;
      return String(field.value || '').trim() === '';
    });
  }

  function areRequiredFieldsValid() {
    const fields = getVisibleRequiredFields();
    if (!fields.length) return false;
    return getInvalidRequiredFields().length === 0;
  }

  function getFieldFriendlyName(field) {
    if (!field) return 'Required field';

    if (field.id === 'wtf-delivery-date') return 'Delivery date';
    if (field.id === 'wtf-card-message-choice') return 'Card message choice';
    if (field.id === 'wtf-card-message') return 'Card message';

    const label = field.id ? document.querySelector('label[for="' + field.id + '"]') : null;
    const labelText = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';

    return labelText || field.placeholder || 'Required field';
  }

  function clearRequiredFieldHighlights() {
    document.querySelectorAll('.wtf-required-field-error').forEach(function (element) {
      element.classList.remove('wtf-required-field-error');
      element.removeAttribute('aria-invalid');
    });

    document.querySelectorAll('.wtf-required-option-error').forEach(function (element) {
      element.classList.remove('wtf-required-option-error');
    });
  }

  function highlightRequiredFields(fields) {
    clearRequiredFieldHighlights();

    fields.forEach(function (field) {
      field.classList.add('wtf-required-field-error');
      field.setAttribute('aria-invalid', 'true');

      const option = field.closest('.wtf-native-option, .product-form__input, .product-form__input--dropdown');
      if (option) {
        option.classList.add('wtf-required-option-error');
      }
    });
  }

  function getOrCreateRequiredPopup() {
    let popup = document.querySelector('.wtf-required-popup');
    if (popup) return popup;

    popup = document.createElement('div');
    popup.className = 'wtf-required-popup';
    popup.setAttribute('role', 'alertdialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-hidden', 'true');

    popup.innerHTML = [
      '<div class="wtf-required-popup__panel">',
      '<button type="button" class="wtf-required-popup__close" aria-label="Close">×</button>',
      '<div class="wtf-required-popup__title">Just a couple of details needed</div>',
      '<div class="wtf-required-popup__message">Please complete the highlighted options before adding this item to your bag.</div>',
      '<ul class="wtf-required-popup__list"></ul>',
      '<button type="button" class="wtf-required-popup__button">OK</button>',
      '</div>'
    ].join('');

    document.body.appendChild(popup);

    popup.addEventListener('click', function (event) {
      if (
        event.target === popup ||
        event.target.closest('.wtf-required-popup__close') ||
        event.target.closest('.wtf-required-popup__button')
      ) {
        popup.classList.remove('is-visible');
        popup.setAttribute('aria-hidden', 'true');
      }
    });

    return popup;
  }

  function showRequiredOptionsPopup(fields) {
    const popup = getOrCreateRequiredPopup();
    const list = popup.querySelector('.wtf-required-popup__list');
    const uniqueNames = Array.from(new Set(fields.map(getFieldFriendlyName)));

    if (list) {
      list.innerHTML = uniqueNames.map(function (name) {
        return '<li>' + name + '</li>';
      }).join('');
    }

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');

    const button = popup.querySelector('.wtf-required-popup__button');
    if (button) button.focus();
  }

  function showRequiredOptionsValidation() {
    const invalidFields = getInvalidRequiredFields();
    if (!invalidFields.length) return true;

    highlightRequiredFields(invalidFields);
    showRequiredOptionsPopup(invalidFields);

    const firstInvalidField = invalidFields[0];
    const target = firstInvalidField.closest('.wtf-native-option') || firstInvalidField;

    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return false;
  }

  function updateRequiredAttributes() {
    const container = getInfiniteOptionsBlock();
    if (!container) return;
    const shouldRequire = hasPrimaryVariantChoice();
    container.querySelectorAll('input, textarea, select').forEach(function (field) {
      const name = (field.name || '').toLowerCase();
      const id = (field.id || '').toLowerCase();
      const placeholder = (field.placeholder || '').toLowerCase();
      const isDeliveryField = id.includes('delivery') || id.includes('date') || name.includes('delivery') || name.includes('date') || placeholder.includes('delivery') || placeholder.includes('date');
      const isCardMessageField = id.includes('card') || id.includes('message') || name.includes('card') || name.includes('message') || placeholder.includes('card') || placeholder.includes('message');
      if (isDeliveryField || isCardMessageField) {
        if ((isDeliveryField || isCardMessageField) && shouldRequire) {
          field.setAttribute('required', 'required');
          field.setAttribute('aria-required', 'true');
        } else {
          field.removeAttribute('required');
          field.removeAttribute('aria-required');
        }
      }
    });
  }

  function updateAddToCartState() {
    const addButton = getAddToCartButton();
    if (!addButton) return;
    const shouldEnable = hasPrimaryVariantChoice();
    const hasMissingCustomOptions = shouldEnable && !areRequiredFieldsValid();

    addButton.disabled = !shouldEnable;
    addButton.setAttribute('aria-disabled', String(!shouldEnable));
    addButton.classList.toggle('is-disabled-by-custom-js', !shouldEnable);
    addButton.classList.toggle('is-awaiting-required-options', hasMissingCustomOptions);
  }

  function toggleProductActionsVisibility() {
    const hasPrimaryOption = hasPrimaryVariantChoice();
    const priceBlock = document.querySelector('#price-template--26407413907837__main, .price-hidden-until-size');
    const infiniteOptionsBlock = getInfiniteOptionsBlock();
    const quantityBlock = getQuantityBlock();
    const secondaryOptionWrappers = getSecondaryOptionWrappers();
    if (priceBlock) priceBlock.classList.toggle('price-hidden-until-size', !hasPrimaryOption);
    if (infiniteOptionsBlock) infiniteOptionsBlock.classList.toggle('hidden-until-size', !hasPrimaryOption);
    if (quantityBlock) quantityBlock.classList.toggle('hidden-until-size', !hasPrimaryOption);
    secondaryOptionWrappers.forEach(function (wrapper) {
      wrapper.classList.toggle('hidden-until-size', !hasPrimaryOption);
    });
  }

  function enforceBespokeMinimum() {
    const quantityInput = getQuantityInput();
    const bespokeSelect = getBespokeSelect();
    if (!quantityInput || !bespokeSelect) return;
    const minQty = getBespokeMinQty();
    const fallbackMin = 1;
    const firstOption = bespokeSelect.querySelector('option');
    const placeholderValue = firstOption ? firstOption.value : '';
    const isBespoke = bespokeSelect.value === placeholderValue;
    const targetMin = isBespoke ? minQty : fallbackMin;
    setQuantityMin(quantityInput, targetMin);
    const currentQty = parseInt(quantityInput.value || '1', 10);
    if (isNaN(currentQty) || currentQty < targetMin) {
      quantityInput.value = String(targetMin);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function handleMinusClick(event) {
    const minusButton = event.target.closest('.quantity__button[name="minus"]');
    if (!minusButton) return;
    const quantityInput = getQuantityInput();
    if (!quantityInput || !isBespokeActive()) return;
    const minQty = getBespokeMinQty();
    const currentQty = parseInt(quantityInput.value || '1', 10);
    if (currentQty <= minQty) {
      event.preventDefault();
      showMinQtyMessage('Minimum bespoke quantity is ' + minQty + '.');
    }
  }

  function focusFirstInvalidField() {
    const firstInvalidField = getInvalidRequiredFields()[0];
    if (firstInvalidField) firstInvalidField.focus();
  }

  function updateDisplayPrice() {
  const quantityInput = getQuantityInput();
  if (!quantityInput) return;
  const currentQty = parseInt(quantityInput.value, 10) || 1;

  // 1. UPDATE THE MAIN PRODUCT PRICE
  const priceDisplays = document.querySelectorAll('.price-item--regular:not(.price-item--last)'); 
  
  priceDisplays.forEach(function(priceDisplay) {
    if (!priceDisplay.dataset.basePrice) {
      const rawPriceText = priceDisplay.textContent.replace(/[^0-9.]/g, '');
      const initialPrice = parseFloat(rawPriceText);
      if (!isNaN(initialPrice) && initialPrice > 0) {
         priceDisplay.dataset.basePrice = initialPrice;
      }
    }
    const basePrice = parseFloat(priceDisplay.dataset.basePrice);
    if (isNaN(basePrice)) return;
    
    const newTotal = (basePrice * currentQty).toFixed(2);
    const newText = '£' + newTotal;
    
    if (priceDisplay.textContent !== newText) {
      priceDisplay.textContent = newText;
    }
  });

  // 2. UPDATE SEAL SUBSCRIPTIONS WIDGET PRICES
  // Seal puts its prices inside .sls-price .money
  const sealPriceSpans = document.querySelectorAll('.sls-price .money.seal-money');
  
  sealPriceSpans.forEach(function(span) {
    // Save original price
    if (!span.dataset.basePrice) {
      const rawSpanText = span.textContent.replace(/[^0-9.]/g, '');
      const initialWidgetPrice = parseFloat(rawSpanText);
      if (!isNaN(initialWidgetPrice) && initialWidgetPrice > 0) {
         span.dataset.basePrice = initialWidgetPrice;
      }
    }

    const widgetBasePrice = parseFloat(span.dataset.basePrice);
    if (isNaN(widgetBasePrice)) return;
    
    const newWidgetTotal = (widgetBasePrice * currentQty).toFixed(2);
    
    // Just replace the raw number since your theme/apps format the £ symbol outside or via CSS
    if (span.textContent !== newWidgetTotal) {
      span.textContent = newWidgetTotal;
    }
  });
}

function runAll() {
    buildNativeLineItemOptions();
    toggleProductActionsVisibility();
    updateRequiredAttributes();
    enforceBespokeMinimum();
    updateAddToCartState();
    updateDisplayPrice();
}

  const addButton = getAddToCartButton();
  if (addButton) {
    addButton.disabled = true;
    addButton.setAttribute('aria-disabled', 'true');
  }

  runAll();
  document.addEventListener('click', handleMinusClick);

document.addEventListener('click', function(event) {
  if (event.target.closest('.quantity__button')) {
    setTimeout(runAll, 50);
  }
});
  document.addEventListener('click', function (event) {
    const clickedAddButton = event.target.closest('button[name="add"]');
    if (!clickedAddButton) return;
    if (clickedAddButton.disabled || !hasPrimaryVariantChoice()) return;

    runAll();

    if (!areRequiredFieldsValid()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      showRequiredOptionsValidation();
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('#wtf-native-options-container')) {
      clearRequiredFieldHighlights();
    }

    if (event.target.matches('select[name="options[Size]"]') || event.target.matches('select[name="options[Select your colourway]"]') || event.target.closest('.product-form__input--dropdown') || event.target.closest('#infiniteoptions-container') || event.target.closest('#wtf-native-options-container') || event.target.matches('input[name="quantity"]')) {
      setTimeout(runAll, 0);
    }
  });
  document.addEventListener('input', function (event) {
    if (event.target.closest('#wtf-native-options-container')) {
      clearRequiredFieldHighlights();
    }

    if (event.target.closest('#infiniteoptions-container') || event.target.closest('#wtf-native-options-container') || event.target.matches('input[name="quantity"]')) setTimeout(runAll, 0);
  });

  const form = getProductForm();
  if (form) {
    form.addEventListener('submit', function (event) {
      runAll();
      const valid = hasPrimaryVariantChoice() && areRequiredFieldsValid();
      if (!valid) {
        event.preventDefault();
        event.stopPropagation();
        showRequiredOptionsValidation();
      }
    }, true);
  }

  const target = document.querySelector('main') || document.body;

if (!(window.Shopify && Shopify.designMode)) {
  const observer = new MutationObserver(function() {
    runAll();
  });
  observer.observe(target, { childList: true, subtree: true });
}
});

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.header-bar--left');
  if (!container) return;
  const shopLink = document.createElement('a');
  shopLink.href = '/collections/luxury-flowers-london';
  shopLink.className = 'header-shop-link';
  shopLink.textContent = 'SHOP';
  container.appendChild(shopLink);
});

document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('SiteHeader');
  if (!header) return;
  const hasTransparentHomeHeader = header.classList.contains('hdr-trans-hp');
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollTolerance = 2;

  function updateHeaderState() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = header.offsetHeight;
    const atTop = scrollTop <= 0;
    const scrollingUp = scrollTop < (lastScrollTop - scrollTolerance);
    const scrollingDown = scrollTop > (lastScrollTop + scrollTolerance);
    const scrollAwayOffset = Math.min(scrollTop, headerHeight);
    const wasWhiteVisible = header.classList.contains('header-white-visible');
    const wasWhiteHidden = header.classList.contains('header-white-hidden');
    const wasTransparentHome = header.classList.contains('hdr-trans-hp');

    header.classList.remove('header-transparent-scrollaway', 'header-standard-scrollaway', 'header-home-white', 'header-standard-white', 'header-white-visible', 'header-white-hidden', 'is-scrolling-up', 'is-scrolling-down');

    if (hasTransparentHomeHeader) {
      header.style.setProperty('--header-scroll-offset', scrollAwayOffset + 'px');
      if (atTop) {
        header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (scrollingDown) {
        header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway', 'is-scrolling-down');
      } else if (scrollingUp) {
        header.classList.remove('hdr-trans-hp');
        header.classList.add('header-home-white', 'header-white-visible', 'is-scrolling-up');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (wasWhiteVisible || wasWhiteHidden) {
        header.classList.add('header-home-white', 'header-white-visible');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (wasTransparentHome) {
        header.classList.add('hdr-trans-hp', 'header-transparent-scrollaway');
      } else {
        header.classList.add('header-home-white');
        header.style.setProperty('--header-scroll-offset', '0px');
      }
    } else {
      header.style.setProperty('--header-scroll-offset', scrollAwayOffset + 'px');
      if (atTop) {
        header.classList.add('header-standard-scrollaway');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (scrollingDown) {
        header.classList.add('header-standard-scrollaway', 'is-scrolling-down');
      } else if (scrollingUp) {
        header.classList.add('header-standard-white', 'header-white-visible', 'is-scrolling-up');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else if (wasWhiteVisible || wasWhiteHidden) {
        header.classList.add('header-standard-white', 'header-white-visible');
        header.style.setProperty('--header-scroll-offset', '0px');
      } else {
        header.classList.add('header-standard-scrollaway');
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', updateHeaderState);
});

class ProductCardSwipe {
  constructor(container) {
    this.container = container;
    this.gridItem = container.closest('.grid__item');
    if (this.isDoubleWidth()) return;

    this.viewport = container.querySelector('.wtf-card-carousel-viewport');
    this.track = container.querySelector('.wtf-card-carousel-image-track');
    this.realSlides = Array.from(container.querySelectorAll('.wtf-card-carousel-image-slide:not(.wtf-card-carousel-image-slide--clone)'));
    this.prev = container.querySelector('.wtf-card-carousel-arrow--prev');
    this.next = container.querySelector('.wtf-card-carousel-arrow--next');
    this.progressSegments = Array.from(container.querySelectorAll('.wtf-card-carousel-track-segment'));
    this.cardLink = container.closest('a');

    this.index = 0;
    this.position = 1;
    this.realSlideCount = this.realSlides.length;
    this.startX = 0;
    this.currentX = 0;
    this.dragging = false;
    this.hasDragged = false;
    this.isAnimating = false;
    this.wheelLocked = false;

    if (!this.viewport || !this.track || this.realSlides.length <= 1) return;

    this.setupInfiniteTrack();
    this.container.classList.add('wtf-card-carousel-ready');
    this.preloadImages();
    this.bind();
    this.jumpToPosition(this.position);
    this.updateState();
  }

  isDoubleWidth() {
    return this.gridItem && this.gridItem.classList.contains('grid__item_double_width');
  }

  setupInfiniteTrack() {
    if (this.track.dataset.wtfInfiniteReady === 'true') {
      this.slides = Array.from(this.track.querySelectorAll('.wtf-card-carousel-image-slide'));
      return;
    }

    const firstClone = this.realSlides[0].cloneNode(true);
    const lastClone = this.realSlides[this.realSlides.length - 1].cloneNode(true);

    firstClone.classList.add('wtf-card-carousel-image-slide--clone');
    lastClone.classList.add('wtf-card-carousel-image-slide--clone');
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');

    this.track.insertBefore(lastClone, this.realSlides[0]);
    this.track.appendChild(firstClone);

    this.track.dataset.wtfInfiniteReady = 'true';
    this.slides = Array.from(this.track.querySelectorAll('.wtf-card-carousel-image-slide'));
  }

  preloadImages() {
    this.slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img) return;
      const preloadImage = new Image();
      if (img.srcset) preloadImage.srcset = img.srcset;
      preloadImage.sizes = img.sizes || '100vw';
      preloadImage.src = img.currentSrc || img.src;
    });
  }

  bind() {
    this.prev.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.goTo(this.index - 1);
    }, true);

    this.next.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.goTo(this.index + 1);
    }, true);

    this.viewport.addEventListener('pointerdown', (event) => this.pointerDown(event));
    this.viewport.addEventListener('pointermove', (event) => this.pointerMove(event));
    this.viewport.addEventListener('pointerup', (event) => this.pointerUp(event));
    this.viewport.addEventListener('pointercancel', (event) => this.pointerUp(event));
    this.viewport.addEventListener('lostpointercapture', (event) => this.pointerUp(event));
    this.viewport.addEventListener('touchstart', (event) => this.touchStart(event), { passive: true });
    this.viewport.addEventListener('touchmove', (event) => this.touchMove(event), { passive: false });
    this.viewport.addEventListener('touchend', (event) => this.touchEnd(event), { passive: true });
    this.viewport.addEventListener('touchcancel', (event) => this.touchEnd(event), { passive: true });
    this.viewport.addEventListener('wheel', (event) => this.handleWheel(event), { passive: false });

    this.cardLink?.addEventListener('click', (event) => {
      if (this.hasDragged) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.hasDragged = false;
      }
    }, true);
  }

  pointerDown(event) {
    if (event.pointerType === 'touch') return;
    if (this.isDoubleWidth()) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    this.dragging = true;
    this.hasDragged = false;
    this.startX = event.clientX;
    this.currentX = event.clientX;
    this.track.style.transition = 'none';
    this.container.classList.add('is-swiping', 'is-touched');

    if (this.viewport.setPointerCapture && typeof event.pointerId !== 'undefined') {
      this.viewport.setPointerCapture(event.pointerId);
    }
  }

  pointerMove(event) {
    if (!this.dragging) return;

    this.currentX = event.clientX;
    const diff = this.currentX - this.startX;

    if (Math.abs(diff) > 6) this.hasDragged = true;

    if (this.hasDragged) {
      event.preventDefault();
    }

    const slideWidth = this.viewport.getBoundingClientRect().width || this.container.getBoundingClientRect().width;
    const currentOffset = this.position * slideWidth;

    this.track.style.transition = 'none';
    this.track.style.transform = `translate3d(${diff - currentOffset}px, 0, 0)`;
  }

  pointerUp(event) {
    if (!this.dragging) return;

    if (event && this.viewport.releasePointerCapture && typeof event.pointerId !== 'undefined') {
      try {
        this.viewport.releasePointerCapture(event.pointerId);
      } catch (e) {}
    }

    const diff = this.currentX - this.startX;
    const threshold = this.viewport.offsetWidth * 0.18;

    this.track.style.transition = '';

    if (diff < -threshold) this.goTo(this.index + 1);
    else if (diff > threshold) this.goTo(this.index - 1);
    else this.updatePosition();

    this.dragging = false;
    setTimeout(() => this.container.classList.remove('is-swiping'), 500);
  }

  touchStart(event) {
    if (this.isDoubleWidth()) return;
    if (!event.touches || event.touches.length !== 1) return;

    this.dragging = true;
    this.hasDragged = false;
    this.startX = event.touches[0].clientX;
    this.currentX = event.touches[0].clientX;
    this.track.style.transition = 'none';
    this.container.classList.add('is-swiping', 'is-touched');
  }

  touchMove(event) {
    if (!this.dragging || !event.touches || event.touches.length !== 1) return;

    this.currentX = event.touches[0].clientX;
    const diff = this.currentX - this.startX;

    if (Math.abs(diff) > 6) this.hasDragged = true;
    if (this.hasDragged) event.preventDefault();

    const slideWidth = this.viewport.getBoundingClientRect().width || this.container.getBoundingClientRect().width;
    const currentOffset = this.position * slideWidth;

    this.track.style.transition = 'none';
    this.track.style.transform = `translate3d(${diff - currentOffset}px, 0, 0)`;
  }

  touchEnd() {
    if (!this.dragging) return;

    const diff = this.currentX - this.startX;
    const threshold = this.viewport.offsetWidth * 0.18;

    this.track.style.transition = '';

    if (diff < -threshold) this.goTo(this.index + 1);
    else if (diff > threshold) this.goTo(this.index - 1);
    else this.updatePosition();

    this.dragging = false;
    setTimeout(() => this.container.classList.remove('is-swiping'), 500);
  }

  handleWheel(event) {
    if (this.isDoubleWidth()) return;

    const horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY) && Math.abs(event.deltaX) > 12;
    if (!horizontalIntent) return;

    event.preventDefault();
    event.stopPropagation();

    if (this.wheelLocked || this.isAnimating) return;

    this.wheelLocked = true;

    if (event.deltaX > 0) {
      this.goTo(this.index + 1);
    } else {
      this.goTo(this.index - 1);
    }

    setTimeout(() => {
      this.wheelLocked = false;
    }, 520);
  }

  goTo(index) {
    if (this.isAnimating) return;

    this.isAnimating = true;

    if (index >= this.realSlideCount) {
      this.index = 0;
      this.position = this.realSlideCount + 1;
      this.updatePosition(() => {
        this.position = 1;
        this.jumpToPosition(this.position);
        this.isAnimating = false;
      });
      this.updateState();
      return;
    }

    if (index < 0) {
      this.index = this.realSlideCount - 1;
      this.position = 0;
      this.updatePosition(() => {
        this.position = this.realSlideCount;
        this.jumpToPosition(this.position);
        this.isAnimating = false;
      });
      this.updateState();
      return;
    }

    this.index = index;
    this.position = index + 1;
    this.updatePosition(() => {
      this.isAnimating = false;
    });
    this.updateState();
  }

  updatePosition(afterTransition) {
    this.track.style.transition = 'transform 280ms ease';
    this.track.style.transform = `translate3d(-${this.position * 100}%, 0, 0)`;

    if (typeof afterTransition === 'function') {
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.track.removeEventListener('transitionend', finish);
        afterTransition();
      };

      this.track.addEventListener('transitionend', finish);
      setTimeout(finish, 360);
    }
  }

  jumpToPosition(position) {
    this.track.style.transition = 'none';
    this.track.style.transform = `translate3d(-${position * 100}%, 0, 0)`;
    this.track.offsetHeight;
    this.track.style.transition = '';
  }

  updateState() {
    this.realSlides.forEach((slide, index) => {
      const isActive = index === this.index;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    if (this.progressSegments) {
      this.progressSegments.forEach((segment, index) => segment.classList.toggle('is-active', index === this.index));
    }

    if (this.prev) this.prev.disabled = false;
    if (this.next) this.next.disabled = false;
  }
}

document.addEventListener('click', function (event) {
  const arrow = event.target.closest('.wtf-card-carousel-arrow');
  if (!arrow) return;
  const container = arrow.closest('[data-wtf-card-carousel], .wtf-card-carousel');
  if (!container || !container.wtfProductCardSwipe) return;
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
  if (arrow.classList.contains('wtf-card-carousel-arrow--prev')) container.wtfProductCardSwipe.goTo(container.wtfProductCardSwipe.index - 1);
  if (arrow.classList.contains('wtf-card-carousel-arrow--next')) container.wtfProductCardSwipe.goTo(container.wtfProductCardSwipe.index + 1);
}, true);

function initProductCardSwipes() {
  document.querySelectorAll('#product-grid.collection-creative-layout .grid__item:not(.grid__item_double_width) [data-wtf-card-carousel], #product-grid.collection-creative-layout .grid__item:not(.grid__item_double_width) .wtf-card-carousel').forEach((container) => {
    if (container.dataset.wtfSwipeInitialized === 'true') return;
    container.dataset.wtfSwipeInitialized = 'true';
    container.wtfProductCardSwipe = new ProductCardSwipe(container);
  });
}

document.addEventListener('DOMContentLoaded', initProductCardSwipes);
document.addEventListener('shopify:section:load', initProductCardSwipes);
document.addEventListener('shopify:section:reorder', initProductCardSwipes);
window.addEventListener('load', initProductCardSwipes);

document.addEventListener('DOMContentLoaded', () => {
  function syncDoubleWidthCollectionVideos() {
    const grid = document.querySelector('#product-grid.collection-creative-layout');
    if (!grid) return;
    grid.querySelectorAll('.collection-card-video').forEach((video) => {
      const item = video.closest('.grid__item');
      if (!item) return;
      const isDoubleWidth = item.classList.contains('grid__item_double_width');
      if (!video.dataset.initialised) {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        video.removeAttribute('controls');
        video.dataset.initialised = 'true';
      }
      if (isDoubleWidth) {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = true;
        video.playsInline = true;

        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');

        video.preload = 'auto';
        video.setAttribute('preload', 'auto');

        const playVideo = () => {
          if (!item.classList.contains('grid__item_double_width')) return;

          try {
            const playPromise = video.play();

            if (playPromise && typeof playPromise.then === 'function') {
              playPromise
                .then(() => {
                  item.classList.add('video-ready');
                })
                .catch(() => {
                  item.classList.remove('video-ready');

                  setTimeout(() => {
                    video.play()
                      .then(() => item.classList.add('video-ready'))
                      .catch(() => {});
                  }, 300);
                });
            } else {
              item.classList.add('video-ready');
            }
          } catch (e) {
            item.classList.remove('video-ready');
          }
        };

        if (video.readyState < 2) {
          video.load();
        }

        requestAnimationFrame(playVideo);
        setTimeout(playVideo, 150);
        setTimeout(playVideo, 600);

        video.addEventListener('loadedmetadata', playVideo, { once: true });
        video.addEventListener('loadeddata', playVideo, { once: true });
        video.addEventListener('canplay', playVideo, { once: true });
      } else {
        if (!video.paused) video.pause();
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.preload = 'none';
        video.setAttribute('preload', 'none');
        item.classList.remove('video-ready');
        try {
          video.currentTime = 0;
        } catch (e) {}
      }
    });
  }

  function shuffleCollectionGrid() {
    const grid = document.querySelector('#product-grid.collection-creative-layout');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll(':scope > .grid__item')).filter((item) => item.querySelector('.card-product'));
    if (!items.length) return;
    items.forEach((item) => {
      item.classList.remove('grid__item_double_width', 'video-ready');
    });
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item) => grid.appendChild(item));
    const eligiblePositions = [0, 5, 10, 15, 20, 25].filter((i) => i < items.length);
    for (let i = eligiblePositions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [eligiblePositions[i], eligiblePositions[j]] = [eligiblePositions[j], eligiblePositions[i]];
    }
    const doubleWidthCount = Math.min(3, eligiblePositions.length);
    for (let i = 0; i < doubleWidthCount; i++) items[eligiblePositions[i]].classList.add('grid__item_double_width');
    syncDoubleWidthCollectionVideos();
    initProductCardSwipes();
  }

  shuffleCollectionGrid();
  document.addEventListener('shopify:section:load', shuffleCollectionGrid);
  window.addEventListener('load', () => {
    syncDoubleWidthCollectionVideos();
    initProductCardSwipes();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const poaPath = '/products/stairway';
  function getSelectedVariantPrice() {
    const script = document.querySelector('script[type="application/json"][data-selected-variant]');
    if (!script) return null;
    try {
      const variant = JSON.parse(script.textContent);
      return typeof variant.price !== 'undefined' ? Number(variant.price) : null;
    } catch (e) {
      return null;
    }
  }
  function replaceZeroPricesWithPOA(scope) {
    scope.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (el) {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text === '£0.00' || text === '£0') {
        el.textContent = 'POA';
        el.style.textTransform = 'uppercase';
      }
    });
  }
  function updateProductPOA() {
    if (window.location.pathname !== poaPath) return;
    const price = getSelectedVariantPrice();
    const isPOA = price === 0;
    replaceZeroPricesWithPOA(document);
    const qtyForm = document.querySelector('#Quantity-Form-template--26407413907837__main');
    const appBlock = document.querySelector('.product-app-block');
    const buyButtonsWrap = document.querySelector('.product-buy-buttons-wrapper');
    if (qtyForm) qtyForm.style.display = isPOA ? 'none' : '';
    if (appBlock) appBlock.style.display = isPOA ? 'none' : '';
    if (buyButtonsWrap) buyButtonsWrap.style.display = isPOA ? 'none' : '';
  }
  function updateCollectionPOA() {
    document.querySelectorAll('a[href="' + poaPath + '"]').forEach(function (link) {
      const card = link.closest('.card-wrapper, .card, .grid__item, .product-card');
      if (card) replaceZeroPricesWithPOA(card);
    });
  }
  function runPOA() {
    updateProductPOA();
    updateCollectionPOA();
  }
  runPOA();
  document.addEventListener('change', function (e) {
    if (window.location.pathname === poaPath && e.target.closest('variant-selects, form[action*="/cart/add"]')) {
      setTimeout(runPOA, 50);
      setTimeout(runPOA, 200);
    }
  });
  document.addEventListener('click', function (e) {
    if (window.location.pathname === poaPath && e.target.closest('variant-selects')) {
      setTimeout(runPOA, 50);
      setTimeout(runPOA, 200);
    }
  });
  setTimeout(runPOA, 300);
  setTimeout(runPOA, 800);
  });
/* ============================================================
   WILD THINGS FLOWERS — Product page quantity selector
   Paste this at the BOTTOM of assets/custom-script.js and Save.
   Adds a Quantity stepper inside the product form, above ADD TO BAG.
   The stepper stays hidden until a size has been selected.
   Because the theme submits the form via FormData, the chosen
   quantity is passed straight to the cart. No other files needed.
   ============================================================ */
(function () {
  var STYLE_ID = 'wtf-qty-style';
  var SIZE_SELECTOR = 'select[name="options[Size]"], variant-selects select';
 
  function injectStyleOnce() {
    if (document.getElementById(STYLE_ID)) return;
    var css = document.createElement('style');
    css.id = STYLE_ID;
    css.textContent =
      '.wtf-qty-selector{margin:0 0 1.2rem;display:none;}' +
      '.wtf-qty-selector.is-visible{display:block;}' +
      '.wtf-qty-label{display:block;font-size:1.1rem;letter-spacing:.05em;text-transform:uppercase;margin-bottom:.6rem;color:inherit;}' +
      '.wtf-qty-control{display:inline-flex;align-items:center;border:1px solid rgba(0,0,0,.25);}' +
      '.wtf-qty-btn{width:4rem;height:4rem;background:none;border:none;font-size:1.8rem;line-height:1;cursor:pointer;color:inherit;display:flex;align-items:center;justify-content:center;}' +
      '.wtf-qty-btn:hover{background:rgba(0,0,0,.04);}' +
      '.wtf-qty-input{width:4.5rem;height:4rem;text-align:center;border:none;border-left:1px solid rgba(0,0,0,.15);border-right:1px solid rgba(0,0,0,.15);font-size:1.4rem;-moz-appearance:textfield;background:none;color:inherit;}' +
      '.wtf-qty-input::-webkit-outer-spin-button,.wtf-qty-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}';
    document.head.appendChild(css);
  }
 
  // A size counts as "chosen" only when the shopper moves off the
  // placeholder first option ("Please select a size").
  function sizeSelected() {
    var s = document.querySelector(SIZE_SELECTOR);
    return !!(s && s.selectedIndex > 0);
  }
 
  function syncVisibility() {
    var show = sizeSelected();
    document.querySelectorAll('.wtf-qty-selector').forEach(function (w) {
      w.classList.toggle('is-visible', show);
    });
  }
 
  function buildSelector() {
    var wrap = document.createElement('div');
    wrap.className = 'wtf-qty-selector';
    wrap.innerHTML =
      '<label class="wtf-qty-label">Quantity</label>' +
      '<div class="wtf-qty-control">' +
      '<button type="button" class="wtf-qty-btn" data-dir="-1" aria-label="Decrease quantity">−</button>' +
      '<input type="number" name="quantity" class="wtf-qty-input" value="1" min="1" inputmode="numeric" aria-label="Quantity">' +
      '<button type="button" class="wtf-qty-btn" data-dir="1" aria-label="Increase quantity">+</button>' +
      '</div>';
    var input = wrap.querySelector('.wtf-qty-input');
    wrap.querySelectorAll('.wtf-qty-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.dataset.dir, 10);
        if (v < 1) v = 1;
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    return wrap;
  }
 
  function addToForm(form) {
    if (!form || form.querySelector('.wtf-qty-selector')) return;
    var buttons = form.querySelector('.product-form__buttons');
    if (!buttons) return;
    buttons.parentNode.insertBefore(buildSelector(), buttons);
  }
 
  function run() {
    injectStyleOnce();
    document
      .querySelectorAll('product-form form[action*="/cart/add"]')
      .forEach(addToForm);
    syncVisibility();
  }
 
  // Reveal / hide whenever the size dropdown changes.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(SIZE_SELECTOR)) {
      syncVisibility();
    }
  });
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
 
  // Re-insert / re-evaluate if the theme re-renders the product form.
  var obs = new MutationObserver(function () { run(); });
  obs.observe(document.body, { childList: true, subtree: true });
})();